import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type M365MailboxStatusFragment = { __typename?: 'M365MailboxStatus', connected: boolean, grantsSendScope: boolean, mailboxAddress?: string | null };

export type GetM365MailboxStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetM365MailboxStatusQuery = { __typename?: 'Query', m365MailboxStatus: { __typename?: 'M365MailboxStatus', connected: boolean, grantsSendScope: boolean, mailboxAddress?: string | null } };

export type GetM365MailboxAuthorizeUrlQueryVariables = Types.Exact<{
  redirectUri?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetM365MailboxAuthorizeUrlQuery = { __typename?: 'Query', m365MailboxAuthorizeUrl: string };

export type GetM365MailboxAdminConsentUrlQueryVariables = Types.Exact<{
  redirectUri: Types.Scalars['String']['input'];
}>;


export type GetM365MailboxAdminConsentUrlQuery = { __typename?: 'Query', m365MailboxAdminConsentUrl: string };

export const M365MailboxStatusFragmentDoc = new TypedDocumentString(`
    fragment M365MailboxStatus on M365MailboxStatus {
  connected
  grantsSendScope
  mailboxAddress
}
    `, {"fragmentName":"M365MailboxStatus"});
export const GetM365MailboxStatusDocument = new TypedDocumentString(`
    query GetM365MailboxStatus {
  m365MailboxStatus {
    ...M365MailboxStatus
  }
}
    fragment M365MailboxStatus on M365MailboxStatus {
  connected
  grantsSendScope
  mailboxAddress
}`);
export const GetM365MailboxAuthorizeUrlDocument = new TypedDocumentString(`
    query GetM365MailboxAuthorizeUrl($redirectUri: String) {
  m365MailboxAuthorizeUrl(redirectUri: $redirectUri)
}
    `);
export const GetM365MailboxAdminConsentUrlDocument = new TypedDocumentString(`
    query GetM365MailboxAdminConsentUrl($redirectUri: String!) {
  m365MailboxAdminConsentUrl(redirectUri: $redirectUri)
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetM365MailboxStatus: build.query<GetM365MailboxStatusQuery, GetM365MailboxStatusQueryVariables | void>({
      query: (variables) => ({ document: GetM365MailboxStatusDocument, variables })
    }),
    GetM365MailboxAuthorizeUrl: build.query<GetM365MailboxAuthorizeUrlQuery, GetM365MailboxAuthorizeUrlQueryVariables | void>({
      query: (variables) => ({ document: GetM365MailboxAuthorizeUrlDocument, variables })
    }),
    GetM365MailboxAdminConsentUrl: build.query<GetM365MailboxAdminConsentUrlQuery, GetM365MailboxAdminConsentUrlQueryVariables>({
      query: (variables) => ({ document: GetM365MailboxAdminConsentUrlDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetM365MailboxStatusQuery, useLazyGetM365MailboxStatusQuery, useGetM365MailboxAuthorizeUrlQuery, useLazyGetM365MailboxAuthorizeUrlQuery, useGetM365MailboxAdminConsentUrlQuery, useLazyGetM365MailboxAdminConsentUrlQuery } = injectedRtkApi;
